export const VALID_PROMO_CODE = 'TESTCODE10';
export const UNLIMITED_DELIVERY_ID = 'RIDP01';
export const GOOGLE_MAPS_ENDPOINT = (apiKey) =>
  `https://maps.googleapis.com/maps/api/js?key=${apiKey}&v=quarterly&libraries=geometry,drawing,places`;
